module.exports = __webpack_public_path__ + "img/error-api.5383c888.svg";